import { type Product } from '@packages/gql/generated/shopping/graphql';
import { LastSeenDocument } from '@packages/gql/generated/shopping/LastSeenDocument';
import { useSession } from '@packages/utilities';
import { useEffect } from 'react';
import { useMutation } from 'urql';

/* GraphQL */ `
  mutation LastSeen($productId: String!) {
    addLastSeenProduct(productId: $productId) {
      id
    }
  }
`;

/**
 * The hook triggers the `addLastSeenProduct` mutation,
 * which subsequently transfers the provided orderNumber to the LastSeen backend.
 * In this backend, the orderNumber is stored for the particular customer using the JWT token.
 * @param orderNumber - the orderNumber is sent to the lastSeen service
 * @returns null
 */
export const useAddLastSeen = (orderNumber: Product['orderNumber']) => {
  const { loading, jwtToken } = useSession();
  const [, lastSeenMutation] = useMutation(LastSeenDocument);

  // should be called once per DV view
  useEffect(() => {
    if (!loading && jwtToken && orderNumber) {
      lastSeenMutation(
        { productId: orderNumber },
        {
          fetchOptions: () => ({
            headers: { 'x-ec-token': jwtToken },
          }),
        },
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading, orderNumber, jwtToken]);

  return null;
};
